<nz-card nzTitle="Schedule" style="width: 100%;">
	<div *ngIf="trigger">
		<div *ngIf="trigger.triggerDescription" class="row">
			<div class="col field">
				<div><strong>Description</strong><span class="schedule-description"> - {{ trigger.triggerDescription }}</span></div>
			</div>
		</div>
		<div class="row mt-3">
			<div class="col schedule-grid">
				<div class="field">
					<strong>Trigger Name</strong>
					<div>{{ trigger.triggerName }}</div>
				</div>

				<div class="field">
					<strong>Trigger Type</strong>
					<div>{{ trigger.triggerType }}</div>
				</div>

				<div class="field" *ngIf="trigger.frequency">
					<strong>Frequency</strong>
					<div>{{ trigger.frequency }}</div>
				</div>

				<div class="field" *ngIf="trigger.reminderBefore">
					<strong>Reminder Before</strong>
					<div>{{ trigger.reminderBefore }} {{ trigger.reminderBeforeValue || '' }}</div>
				</div>

				<div class="field">
					<strong>Time</strong>
					<div>{{ trigger.triggerTime || '-' }}</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="!trigger">No schedule applied</div>
	
</nz-card>